import axios from 'axios'
import _ from 'lodash'

export default {
	namespaced: true,
	state: {
        loadingProperty: false,
		property: [],
		files: {
			videos: [],
			audios: [],
			images: [],
			docs:   [],
			norma: [],
			potalogy: [],
		},
		genders: [],
		pathologies: [],
		all: true,
		newProperty: null
	},
	getters: {
		getLoadingProperty: state => state.loadingProperty,
		getProperty: state => state.property,
		getFiles: state => state.files,
		genders: state => state.genders,
		pathologies: state => state.pathologies
	},
	mutations: {
        changeConstructor(state, object) {
            state[object.name] = object.value
        },
        changeFlagConstructor(state, object) {
            state[object.name] = object.value;
        },
		addPropertyFile(state, file) {
			state.property.push(file)
		},
		setPropertyFiles(state, file) {
			state.property = file.map(item => {
				item.update = false
				return item
			})
		},
		setFiles(state, files) {
			if (state.all) {
				state.files.norma = []
				files.map(item => {
					state.files.norma.push(item)
				})
			} else {
				state.files.potalogy = []
				files.map(item => {
					state.files.potalogy.push(item)
				})
			}
			state.all = !state.all
		},
		setDeleteFile(state, id) {
			state.property.map((item, index) => {
				if (item.id == id) state.property.splice(index, 1)
			})
		},
		updateFile(state, data) {
			state.newProperty = data
		},
		setGenders(state, data) {
			state.genders = data
		},
		setPathologies(state, data) {
			data.forEach(x => { 
				x.openSubtypes = false, 
				x.openSymptoms = false,
				x.subtypes.forEach(y => y.openSymptoms = false)
			})
			state.pathologies = data
		},
	},
	actions: {
		createPropertyFile({ commit, rootState }, data) {
			const dgws = data.dgws.length ? data.dgws.map(item => {
				return `&dgws=${item}`
			}).join('') : ''

			const fileids = data.fileids.length ? data.fileids.map(item => {
				return `&fileids=${item}`
			}).join('') : ''

			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}Property/Create?${dgws}${fileids}`, {
					"id": "0",
					"treeItemId": data.nodeid,
					"indicatorName": data.iname,
					"indicatorValue": data.ivalue,
					"mediaFileId": data.fileids.length > 0 ? data.fileids[0] : null,
					"isNormal": data.isnormal,
					"order": 0,
					"valueType": 0,
					"minValue": 0,
					"maxValue": 0,
					"dictionaryValueId": "0",
					"dictionaryValue": "",
					"ageOnMonth": 0,
					"isVisible": true,
					"propertyListValues": []
				})
				.then(resp => {
					commit('addPropertyFile', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		updatePropertyFile({ rootState }, data) {
			const dgws = data.dgws.length ? data.dgws.map(item => {
				return `&dgws=${item}`
			}).join('') : ''
			
			const fileids = data.fileids.length ? data.fileids.map(item => {
				return `&fileids=${item}`
			}).join('') : ''

			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}Property/Update?${dgws}${fileids}`, {
					"id": data.nodeid,
					"treeItemId": 0,
					"indicatorName": data.iname,
					"indicatorValue": data.ivalue,
					"mediaFileId": 0,
					"isNormal": data.isnormal,
					"order": 0,
					"valueType": 0,
					"minValue": 0,
					"maxValue": 0,
					"dictionaryValueId": 0,
					"dictionaryValue": "string",
					"ageOnMonth": 0,
					"isVisible": true,
					"propertyListValues": []
				})
				.then(resp => {
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		getPropertyFiles({ commit, rootState }, data) {
			return new Promise((resolve, reject) => {
				axios.get(`${rootState.api}Property/GetByNode?nodeid=${data.id}&isnormal=${data.isnormal}`)
				.then(resp => {
					commit('setPropertyFiles', resp.data)
					commit('setFiles', resp.data)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		deletePropertyFiles({ commit, rootState }, id) {
			return new Promise((resolve, reject) => {
				axios.post(`${rootState.api}Property/Delete?propertyid=${id}`)
				.then(resp => {
					commit('setDeleteFile', id)
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		getGenders({ commit, rootState }) {
			return new Promise((resolve, reject) => {
				axios.get(`${rootState.api}BodyTree/GetUniversalHumans`)
				.then(response => {
					let male = response.data.find(x => x.gender === 1);
					let female = response.data.find(x => x.gender === 2);

					let genders = []
					genders.push({ id: male.id, gender: male.gender, name: 'М' })
					genders.push({ id: female.id, gender: female.gender, name: 'Ж' })
					genders.push({ id: '00000000-0000-0000-0000-000000000000', gender: 0, name: 'МЖ' })
					commit('setGenders', genders)

					resolve(response)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		getPathologies({ commit, rootState }, addSymptoms) {
			return new Promise((resolve, reject) => {
				axios.get(`${rootState.api}Pathology/GetAll?addSymptoms=${addSymptoms}`)
				.then(response => {
					commit('setPathologies', response.data)
					resolve(response)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
	}
};
